<template>
  <v-date-picker
    no-title
    style="padding-bottom: 8px !important;"
    :allowed-dates="type === 'startDate' ? startDateAllowed : endDateAllowed"
    :value="value"
    @change="handleChange"
  />
</template>

<script>
import { utils } from 'frontend-js-shared'

export default {
  name: 'DatePicker',

  props: { type: String, startDate: String, endDate: String },

  computed: {
    value() {
      return this.type === 'startDate' ? this.startDate : this.endDate
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value)
    },

    startDateAllowed(date) {
      if (!this.endDate) return true

      return utils.dates.calculateDifferenceInDays(date, this.endDate) >= 0
    },
    endDateAllowed(date) {
      if (!this.startDate) return true

      return utils.dates.calculateDifferenceInDays(this.startDate, date) >= 0
    },
  },
}
</script>
